import Vue from 'vue'
import myDrawer from './myDrawer/index.vue'
import myDialog from './myDialog/index.vue'
import myTitleName from './myTitleName/index.vue'
import myTableSearch from './myTableSearch/index.vue'
import myForm from './myForm/index.vue'
import myMapDrawer from './myMapDrawer/index.vue'
import mySubmitButton from './mySubmitButton/index.vue'
import myPageAdd from './myPageAdd/index.vue'
let obj = {
  myDialog,
  myDrawer,
  myTitleName,
  myTableSearch,
  myForm,//form表单
  myMapDrawer,
  mySubmitButton,//form提交按钮
  myPageAdd,//页面新增
}

for (const key in obj) {
  Vue.component(key,obj[key]);
}
